import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Routes from '../../containers/routes';
import { SIMPLE_SIGN_ROUTE, HELLO_SIGN_ROUTE } from '../../constants/globals';

export default () => (
  <Switch>
    <Route
      path={HELLO_SIGN_ROUTE}
      exact
      component={Routes.SignDocument}
    />
    <Route
      path={SIMPLE_SIGN_ROUTE}
      exact
      component={Routes.SimpleSignDocuments}
    />
  </Switch>
);



// WEBPACK FOOTER //
// ./src/components/AppRouter/AppRouter.jsx